import { RefreshIcon } from "@heroicons/react/outline";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

import { useGridContext } from "../hooks/useEvaluateGridContext";

import { cn } from "@/lib/utils";

export const ColumnPinningSection = observer(() => {
  const { gridApiRef } = useGridContext();
  const [hasPinnedColumns, setHasPinnedColumns] = useState(false);

  const handleUnpinAllColumns = () => {
    const columns = gridApiRef?.current?.getColumns();
    if (!columns) {
      return;
    }

    columns.forEach(col => {
      gridApiRef.current?.setColumnsPinned([col.getColId()], null);
      gridApiRef.current?.applyColumnState({
        state: [
          {
            ...col,
            colId: col.getColId(),
            pinned: null,
          },
        ],
      });
    });

    setHasPinnedColumns(false);
  };

  useEffect(() => {
    gridApiRef.current?.addEventListener("columnPinned", event => {
      setHasPinnedColumns(event.pinned !== null);
    });
  }, [gridApiRef]);

  return (
    <div className="border-t border-gray-200 pt-1.5">
      <h4 className="mb-1.5 text-xs font-medium uppercase tracking-wide text-gray-600">Unpin</h4>
      <div className="space-y-0.5">
        <button
          className={cn(
            "flex w-full items-center gap-2.5 rounded-md px-2.5 py-1.5 text-left text-sm transition-colors",
            hasPinnedColumns
              ? "text-gray-700 hover:bg-gray-100"
              : "cursor-not-allowed text-gray-400",
          )}
          onClick={handleUnpinAllColumns}
          disabled={!hasPinnedColumns}
        >
          <RefreshIcon className="h-4 w-4 flex-shrink-0" />
          <div className="min-w-0">
            <div className="font-medium">Unpin all columns</div>
            <div className={cn("text-xs text-gray-500", !hasPinnedColumns && "text-gray-400")}>
              Remove all column pinning
            </div>
          </div>
        </button>
      </div>
    </div>
  );
});
